var _rect, _rect2, _rect3, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeapDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 136,
    viewBox: "0 0 137 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.1934,
    y: 33,
    width: 66,
    height: 86,
    rx: 4,
    fill: "#1F1D1A",
    fillOpacity: 0.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1934,
    y: 99,
    width: 24,
    height: 10,
    rx: 1,
    fill: "url(#paint0_linear_12177_194127)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1934,
    y: 99,
    width: 24,
    height: 10,
    rx: 1,
    fill: "#1F1D1A",
    fillOpacity: 0.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1934 37C35.1934 34.7909 36.9842 33 39.1934 33H97.1934C99.4025 33 101.193 34.7909 101.193 37V41H35.1934V37Z",
    fill: "#B7B6B4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12177_194127)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.1934,
    cy: 68,
    r: 20,
    fill: "#1F1D1A",
    fillOpacity: 0.03
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8169 70.9681C77.8169 74.4003 73.6269 75.7951 68.4211 75.7951C63.2152 75.7951 58.9648 74.4003 58.9648 70.9681C58.9648 67.536 63.1877 64.7573 68.3881 64.7573C73.594 64.7573 77.8169 67.5415 77.8169 70.9681Z",
    fill: "#4BAF74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8565 63.4833C76.8565 61.6767 75.3793 60.205 73.5616 60.205C72.5347 60.205 71.6231 60.6717 71.0191 61.4021C70.1954 61.2209 69.3167 61.1165 68.4107 61.1165C67.4991 61.1165 66.6259 61.2154 65.8022 61.4021C65.1927 60.6717 64.2756 60.205 63.2597 60.205C61.442 60.205 59.9648 61.6712 59.9648 63.4833C59.9648 64.0764 60.1241 64.631 60.3987 65.1088C60.1351 65.6689 59.9978 66.262 59.9978 66.8825C59.9978 70.0675 63.7704 72.6485 68.4161 72.6485C73.0619 72.6485 76.8345 70.0675 76.8345 66.8825C76.8345 66.262 76.6917 65.6689 76.4336 65.1088C76.6972 64.631 76.8565 64.0764 76.8565 63.4833Z",
    fill: "#32DA6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.99 65.301C64.0992 65.301 65.0053 64.4059 65.0053 63.2966C65.0053 62.1928 64.1047 61.2922 62.99 61.2922C61.8807 61.2922 60.9746 62.1873 60.9746 63.2966C60.9801 64.4059 61.8807 65.301 62.99 65.301Z",
    fill: "#F1F1E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7321 65.301C74.8414 65.301 75.7475 64.4059 75.7475 63.2966C75.7475 62.1928 74.8469 61.2922 73.7321 61.2922C72.6174 61.2922 71.7168 62.1873 71.7168 63.2966C71.7168 64.4059 72.6174 65.301 73.7321 65.301Z",
    fill: "#F1F1E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9192 75.559C62.353 75.559 62.6935 75.1855 62.6441 74.7572C62.4684 73.2526 61.716 69.9961 58.4157 68.0357C54.0225 65.4273 57.4986 74.4058 57.4986 74.4058L56.587 74.9274C56.2795 75.1032 56.4113 75.559 56.7573 75.559H61.9192Z",
    fill: "#32DA6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0268 75.559C74.6369 75.559 74.3294 75.1855 74.3733 74.7572C74.5271 73.258 75.208 69.9961 78.1844 68.0357C82.1547 65.4273 79.0136 74.4058 79.0136 74.4058L79.8373 74.9274C80.1119 75.1032 79.9965 75.559 79.6835 75.559H75.0268Z",
    fill: "#32DA6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9902 64.2872C63.5425 64.2872 63.9902 63.8394 63.9902 63.3021C63.9902 62.7499 63.5425 62.317 62.9902 62.317C62.438 62.317 61.9902 62.7648 61.9902 63.3021C62.0052 63.8394 62.4529 64.2872 62.9902 64.2872Z",
    fill: "#0D0D0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7305 64.2817C74.2827 64.2817 74.7305 63.8339 74.7305 63.2966C74.7305 62.7444 74.2827 62.3115 73.7305 62.3115C73.1782 62.3115 72.7305 62.7593 72.7305 63.2966C72.7305 63.8339 73.1782 64.2817 73.7305 64.2817Z",
    fill: "#0D0D0D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12177_194127",
    x: 0.193359,
    y: 0,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.113725 0 0 0 0 0.101961 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12177_194127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12177_194127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12177_194127",
    x1: 95.1934,
    y1: 104,
    x2: 71.1934,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapDark);
export default __webpack_public_path__ + "static/media/LeapDark.058c3b9387ce78c6ca1161b664a239e0.svg";
export { ForwardRef as ReactComponent };